import React from "react";
import { Link } from "react-router-dom";
import { BRANDING_LOGO_HORIZONTAL_URL } from "constants/branding";

const footerLinks = [
  { to: "/products/frames", label: "اطارات" },
  { to: "/products/contacts", label: "عدسات لاصقة" },
  { to: "/collections", label: "المجموعات" },
  { to: "/products/frames", label: "عدسات الحماية" },
  { to: "/products/frames", label: "عروض الحرق" },
];

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#f8f8f8] border-t border-[#e6e6e6] mt-16" dir="rtl">
      <div className="container max-w-6xl mx-auto px-4 py-12">
        {/* Top: logo + tagline */}
        <div className="flex flex-col items-center text-center mb-10">
          <Link to="/" className="inline-block mb-3">
            <img src={BRANDING_LOGO_HORIZONTAL_URL} alt="Locoptics" className="h-32 w-auto object-contain" loading="lazy" />
          </Link>
        </div>

        {/* Links: 2-col grid on mobile, single row on md+ */}
        <nav className="grid grid-cols-2 sm:flex sm:flex-wrap sm:items-center sm:justify-center gap-4 sm:gap-x-10 sm:gap-y-4 mb-10 max-w-xs mx-auto sm:max-w-none">
          {footerLinks.map(({ to, label }) => (
            <Link
              key={label}
              to={to}
              className="text-sm font-medium text-gray-600 hover:text-primary transition-colors text-center py-2 sm:py-0"
            >
              {label}
            </Link>
          ))}
        </nav>

        {/* Divider */}
        <hr className="border-[#e6e6e6] mb-8" />

        {/* Bottom: copyright + brand */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-right">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} الوكيل للبصريات. جميع الحقوق محفوظة.
          </p>
          <p className="text-sm text-primary font-medium">® locoptics.ly | الوكيل للبصريات</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
